import camelcaseKeysDeep from 'camelcase-keys-deep';

import { getSettings } from '../api';
import {
  SETTINGS_FETCHING,
  SETTINGS_FETCHED,
  SETTINGS_FETCHED_ERROR,
} from './';

export default function fetchSettings() {
  return async dispatch => {
    dispatch({ type: SETTINGS_FETCHING });

    try {
      const settings = await getSettings();

      dispatch({
        type: SETTINGS_FETCHED,
        settings: camelcaseKeysDeep(settings),
      });
    } catch (error) {
      dispatch({ type: SETTINGS_FETCHED_ERROR });
      console.warn(error);
    }
  };
}
